import axios, { AxiosResponse } from 'axios' 
import {UserModel} from '../models/UserModel'
import { ApiResponse } from '../../../../shared/models/ApiModels'

const API_URL = process.env.REACT_APP_API_URL || ''

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}api/v1/user/getUserByToken`
export const GET_USER_BY_ID = `${API_URL}api/v1/user/`
export const LOGIN_URL = `${API_URL}api/v1/auth/login`
export const REGISTER_URL = `${API_URL}api/v1/auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}api/v1/auth/forgot-password`
export const LOGOUT_URL = `${API_URL}api/v1/auth/logout`

// Server should return AuthModel
export function login(email: string, password: string) { 
  return axios.post(LOGIN_URL, {email, password})
}

// Server should return AuthModel
export function register(email: string, firstName: string, lastName: string, username: string, password: string) {
  return axios.post(REGISTER_URL, {
    email,
    firstName,
    lastName,
    username,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {email})
}
 
export async function getUserByToken(): Promise<AxiosResponse<ApiResponse<UserModel>>> {
  return axios.get(GET_USER_BY_ACCESSTOKEN_URL)
}
 

export function getUserById(id: number) {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  return axios.get<UserModel>(GET_USER_BY_ID + id.toString())
}

export function logout(){
  return axios.post(LOGOUT_URL);
}
